import {AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {of, ReplaySubject} from "rxjs";
import {Ofwca, OfwcaRau} from "../../../../shared/interface/ofwca";
import {Partner} from "../../../../shared/interface/partner";
import {PartnerFacility} from "../../../../shared/interface/partner-facility";
import {MatDialogRef} from "@angular/material/dialog";
import {OfwcaAddDialogComponent} from "../../../ofwcas/ofwca-add-dialog/ofwca-add-dialog.component";
import {DictPartnersComponent} from "../../../../shared/components/dict-partners/dict-partners.component";
import {ReceivablesPaymentImportRow} from "../../../../shared/interface/receivables-payment-import-row";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {MatSnackBar} from "@angular/material/snack-bar";
import {FormHelperService} from "../../../../shared/services/form-helper.service";
import {Router} from "@angular/router";
import {AuthService} from "../../../../shared/services/auth.service";
import {ReceivablesPaymentImportRowService} from "../../../../shared/services/receivables-payment-import-row.service";
import {validPesel} from "../../../../shared/validator/pesel-validator";
import {validPhoneNumber} from "../../../../shared/validator/phone-validator";
import {validIban} from "../../../../shared/validator/iban-validator";
import {delay, first, takeUntil, tap} from "rxjs/operators";
import moment from "moment/moment";
import {Support} from "../../../../shared/interface/support";
import {Dictionary} from "../../../../shared/interface/dictionary";
import {Uuid} from "../../../../shared/interface/response/uuid";
import {HttpErrorResponse} from "@angular/common/http";

@Component({
  selector: 'app-receivables-payment-import-add',
  templateUrl: './receivables-payment-import-add.component.html',
  styleUrls: ['./receivables-payment-import-add.component.scss']
})
export class ReceivablesPaymentImportAddComponent implements OnInit,  OnDestroy, AfterViewInit  {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  private initialized: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  @Input() receivablesPaymentImportsRow?: ReplaySubject<ReceivablesPaymentImportRow>;
  @Input() dialogRef?: MatDialogRef<ReceivablesPaymentImportAddComponent> = null;
  @Output() closeModification = new EventEmitter<any>();
  @Output() receivablesPaymentImportRowCreated = new EventEmitter<string>();


  receivablesPaymentImportsRowObject?: ReceivablesPaymentImportRow = null;
  processingRequest = false;
  formErrors: any = {};
  receivablesPaymentImportRowForm: FormGroup;
  noteControl: FormControl;


  constructor(
    private fb: FormBuilder,
    private snack: MatSnackBar,
    private formHelper: FormHelperService,
    private router: Router,
    private auth: AuthService,
    private receivablesPaymentImportRowService: ReceivablesPaymentImportRowService,
  ) {
    this.receivablesPaymentImportRowForm = this.fb.group({
      note: this.noteControl =  this.fb.control(''),
    });
  }

  ngOnInit(): void {

  }

  ngAfterViewInit(): void {
    if (this.receivablesPaymentImportsRow) {
      this.receivablesPaymentImportsRow.pipe(
        first(),
        delay(0)
      )
        .subscribe((receivablesPaymentImportRow: ReceivablesPaymentImportRow) => {
          this.receivablesPaymentImportsRowObject = receivablesPaymentImportRow;
          this.initialize(receivablesPaymentImportRow);
        });
    } else {
      this.initialized.next(true);
    }
  }

  initialize(receivablesPaymentImportRowForm: ReceivablesPaymentImportRow): void {
    of(receivablesPaymentImportRowForm)
      .pipe(
        delay(0),
        tap(() => {
          this.receivablesPaymentImportRowForm.reset({
            note: receivablesPaymentImportRowForm.note,
          });
        }),
        delay(0),
        tap(() => this.initialized.next(true))
      ).subscribe();
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  sendForm(): void {
    this.processingRequest = true;
    this.formHelper.removeBackendErrorState(this.receivablesPaymentImportRowForm, this.formErrors);
    this.formErrors = {};

    this.receivablesPaymentImportRowService.sendForm(this.receivablesPaymentImportRowForm.getRawValue(), this.receivablesPaymentImportsRowObject ? this.receivablesPaymentImportsRowObject.uuid : null)
      .pipe(
        first()
      )
      .subscribe((response: Uuid) => {
        this.snack.open(this.receivablesPaymentImportsRowObject ? 'Pomyślnie zaktualizowano wpłatę'
          : 'Pomyślnie utworzono wpłatę', '', {
          duration: 2000,
        });
        this.processingRequest = false;
        if (!this.receivablesPaymentImportsRowObject) {
          this.router.navigate(['/naleznosci/wplaty/szczegoly/', response.uuid]);
        } else {
          this.closeModification.emit();
        }
      }, (error: HttpErrorResponse) => {

        this.snack.open(this.receivablesPaymentImportsRowObject ? 'Podczas aktualizacji obiektu wystąpił błąd'
          : 'Podczas tworzenia obiektu wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });

        if (error.status === 400) {
          this.formErrors = error.error.error.list;
          this.formHelper.setBackendErrorState(this.receivablesPaymentImportRowForm, this.formErrors);
        }
      })
    ;
  }

  cancel(): void {
    if (this.dialogRef) {
      this.dialogRef.close();
      return;
    }

    if (!this.receivablesPaymentImportsRowObject) {
      this.router.navigate(['/naleznosci/wplaty/nierozliczone']);
    } else {
      this.closeModification.emit();
    }
  }

}
